import PartilhadosComigo from './PartilhadosComigo'

/** A página /:workspace/partilhados. É onde um convidado chega quando
 *  aceita o convite; o viewer fica montado ao lado, para abrir o que
 *  lá estiver. */
export default function PartilhadosComigoPage() {
  return (
    <div className="h-full overflow-y-auto bg-[var(--color-panel)]">
      <PartilhadosComigo />
    </div>
  )
}
